import styled from 'styled-components';

import {colors} from 'theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const CodeContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 30%;
    min-width: 300px;
    width: 100%;
`;

export const CodeSelect = styled.div`
    color: ${colors.brandPrimary};
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
`;

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${colors.textPrimary};
    text-align: center;
    gap: 10px;

    & > p {
        font-size: 15px;
        font-weight: 500;
        margin: 0;
    }

    & > div {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        width: 100%;

        & > * {
            flex: 1;
        }
    }
`;
